import React, { useRef } from 'react';
import { l } from '../../../../lang/index.jsx';
import Link from "../../../menu-link/LinkHelper.jsx";

export default function SingleContact({navigate, lang, uiMap}) {
    const containerRef = useRef(null);
    const title = uiMap?.['single-contact-title']?.[lang] || l('single-contact-title', lang);
    const content = uiMap?.['single-contact-content']?.[lang] || l('single-contact-content', lang);
    const button = uiMap?.['single-contact-button']?.[lang] || l('single-contact-button', lang);

    const renderContentWithBreaks = (text) => {
        if (!text) return null;
        const parts = text.split(/(?:<br\s*\/?\>|\r?\n|\\n)/i);
        return parts.map((part, i) => (
            <React.Fragment key={i}>
                {part}
                {i < parts.length - 1 && <br />}
            </React.Fragment>
        ));
    };

    return (
        <div key={lang} className="section section-single-contact" ref={containerRef}>
            <div className='home-contact-title'>
                <h2 className="h2">{title}</h2>
            </div>
            <p className="reveal-type paragraph big-text" data-bg-color="transparent" data-fg-color="#fcfbe9">
                {renderContentWithBreaks(content)}
            </p>
            <div className="more-infos">
                <Link navigate={navigate} className='button' href={'/' + 'contact'} aria-label="See the contact page">
                    <span>{button}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                        <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                    </svg>
                </Link>
            </div>
        </div>
    );
}